import React, { Fragment } from "react";
import { TickRenderer } from "../../../../libraries/ReportGenerator/TickRenderer";
import { getTotalMiles } from "../../utils/getTotalMiles";

export const ONR_SurfacingAndLiningRequirementsSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Mileage",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "From",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "from",
            },
            {
              title: "To",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "to",
            },
          ],
        },
        {
          title: "Total Miles",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: ["from", "to"],
          dontJoinValues: true,
          formatter: getTotalMiles,
        },
        {
          title: "Ballast Needed",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "ballas",
        },
        {
          title: "Remarks (crossing circuit, bridge, crossing, etc.)",
          colSpan: 8,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "com",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/SurfacingAndLiningRequirements/ONR_SurfacingAndLiningRequirementsSchema.js